module.exports = __webpack_public_path__ + "static/media/btn.bb0d3930.png";